import { alpha, TextField } from "@mui/material";
import { useContext } from "react";

import Context from "../../../context";

// ----------------------------------------------------------------------

type Props = {
	label: string;
	value: string;
	onChange: (text: string) => void;
};

export const TextInputField = ({ label, onChange, value }: Props) => {
	const { theme } = useContext(Context);

	return (
		<TextField
			fullWidth
			label={label}
			size='small'
			value={value}
			type={"text"}
			onChange={(e) => onChange(e.target.value)}
			sx={{
				"& label": {
					color: theme?.colors?.primaryText ?? "white"
				},
				"& .MuiOutlinedInput-root": {
					"& fieldset": {
						borderColor: alpha(theme?.colors.stroke ?? "", 0.3)
					},
					"&:hover fieldset": {
						borderColor: theme?.colors.primary
					},
					"&.Mui-focused fieldset": {
						borderColor: theme?.colors.primary
					},
					"& input": {
						color: theme?.colors.primaryText
					}
				}
			}}
			InputLabelProps={{
				style: {
					color: alpha(theme?.colors.secondaryText ?? "", 0.8)
				}
			}}
			FormHelperTextProps={{
				style: {
					color: theme?.colors.secondaryText
				}
			}}
		/>
	);
};

export default TextInputField;
